module.exports = __webpack_public_path__ + "static/media/logo_ncb.646ac169.svg";